module.exports = {
	"classes": [
		"tei-page"
	],
	"title": "The Total Economic Impact (TEI) of Auth0",
	"metas": {
		"description": "Forrester Consulting analysis reveals significant ROI after implementation of the Auth0 identity platform."
	},
	"opengraph": {
		"og:title": "The Total Economic Impact (TEI) of Auth0",
		"og:description": "Forrester Consulting analysis reveals significant ROI after implementation of the Auth0 identity platform.",
		"og:url": "https://auth0.com/tei",
		"og:image": "http://cdn.auth0.com/website/tei/tei-twitter-card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/tei/tei-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "The Total Economic Impact (TEI) of Auth0",
		"twitter:description": "Forrester Consulting analysis reveals significant ROI after implementation of the Auth0 identity platform.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/tei/tei-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/tei/metadata.json
// module id = 1436
// module chunks = 0